import React from 'react';
import './styles.scss';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useTranslation } from 'react-i18next';

export default function PartnersSection({ asSubheading = false }) {
  const { t } = useTranslation()

  const data = [
    { partner: t('partners.unicredit'), post: t('partners.unicreditPost'), logo: 'unicredit.png', name: t('partners.unicreditName'), text: t('partners.unicreditText') },
    { partner: t('partners.monbat'), post: t('partners.monbatPost'), logo: 'monbat.png', name: t('partners.monbatName'), text: t('partners.monbatText') },
    { partner: t('partners.AC'), post: t('partners.ACPost'), logo: 'ac.png', name: t('partners.ACName'), text: t('partners.ACText') },
    { partner: t('partners.grandHotelSofia'), post: t('partners.grandHotelSofiaPost'), logo: 'grand-hotel-sofia.png', name: t('partners.grandHotelSofiaName'), text: t('partners.grandHotelSofiaText') },
  ]
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
  };

    // On the home page this section sits below the hero heading, so it must not
  // claim a second <h1>; the class keeps the visual styling identical.
  const Heading = asSubheading ? "h2" : "h1";

return (
    <div className='screen-section-wrapper partners'>
      <div className='section-wrapper text'>
        <div className='title-wrapper'>
          <Heading className={asSubheading ? "section-heading" : undefined}>{t('general.headerPartners')}</Heading>
          <div className='flex'>
            <div className='line' />
            <h2>{t('home.partnersSectionSubtitle')}</h2>
          </div>
        </div>
      </div>
      <div className='cards-wrapper desktop'>
        <Slider {...settings}>
          {data?.map((el, index) => <div className='card-wrapper' key={`web-${el.partner}`}>
            <div className='top'>
              {el.logo && <img src={require(`../../../assets/images/${el.logo}`)} fetchpriority="low" alt='brand logo' />}
              <div className='flex'>
                <p className='partner-name'>{el.name}</p>
                <p className='partner-info'>{el.post}</p>
              </div>
            </div>
            <div className='bottom'>
              <p>{el.text}</p>
            </div>
          </div>)}
        </Slider>
      </div>
      <div className='cards-wrapper mobile'>
        {data?.map((el, index) => <div className='card-wrapper' key={`mobile-${el.partner}`}>
          <div className='top'>
            {el.logo && <img src={require(`../../../assets/images/${el.logo}`)} fetchpriority="low" alt='brand logo' />}
            <div className='flex'>
              <p className='partner-name'>{el.name}</p>
              <p className='partner-info'>{el.post}</p>
            </div>
          </div>
          <div className='bottom'>
            <p>{el.text}</p>
          </div>
        </div>)}
      </div>
    </div>
  )
}
